<script setup lang="ts">

const props = defineProps<{
  organization: any
}>()

const medias = computed(() => {
  const items = []
  if (props.organization.youtube_video_id) {
    items.push({type: 'video', id: props.organization.youtube_video_id})
  }
  if (props.organization.medias?.length) {
    props.organization.medias.forEach((m) => {
      items.push({type: 'image', url: m})
    })
  }
  return items
})

const mediaTitle = computed(() => {
  const counts = medias.value.reduce((acc, m) => {
    acc[m.type] = (acc[m.type] || 0) + 1
    return acc
  }, {})

  const parts = []
  if (counts.video) parts.push('Vidéo')
  if (counts.image) parts.push(`Image${counts.image > 1 ? 's' : ''}`)

  return parts.join(' & ')
})
</script>

<template>
  <div v-if="medias.length">
    <ProseH3>{{mediaTitle}}</ProseH3>
    <UCarousel v-slot="{ item }" arrows dots wheel-gestures :items="medias" class="w-full max-h-75 my-5 mb-20" :ui="{ item: 'sm:basis-auto flex justify-center', prev: 'disabled:hidden sm:start-4 2xl:-start-12', next: 'disabled:hidden sm:end-4 2xl:-end-12' }">
      <img v-if="item.type === 'image'" :src="item.url" class="rounded-lg h-75">
      <ScriptYouTubePlayer
          v-if="item.type === 'video'"
          above-the-fold
          :video-id="item.id"
          class="sm:h-75 max-h-75 rounded-lg"
          :placeholderAttrs="{class: 'rounded-lg', alt: ''}"
      >
        <template #awaitingLoad>
          <div class="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 h-[48px] w-[68px]">
            <svg height="100%" version="1.1" viewBox="0 0 68 48" width="100%"><path d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" fill="#f00" /><path d="M 45,24 27,14 27,34" fill="#fff" /></svg>
          </div>
        </template>
      </ScriptYouTubePlayer>
    </UCarousel>
  </div>
</template>